import { createSlice } from "@reduxjs/toolkit";
//
import { getCategories } from "./thunk";
import { ICategory } from "api/types/_category";
import { IPaginatedResponse } from "api/types/_base";

export interface ICategoryState {
  categories: ICategory[];
  pagination: IPaginatedResponse<ICategory>["pagination"] | null;
  isLoading: boolean;
  isSuccess: boolean;
  error: string | null;
}

export const initialState: ICategoryState = {
  categories: [],
  pagination: null,
  isLoading: false,
  isSuccess: false,
  error: null,
};

const CategorySlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    updateCategoryStatus: (state, action: { payload: { id: number; data: Partial<ICategory> } }) => {
      const { id, data } = action.payload;
      const index = state.categories.findIndex((cat) => cat.id === id);
      if (index !== -1) {
        state.categories[index] = { ...state.categories[index], ...data };
      }
    },
    updateCategory: (state, action: { payload: { data: ICategory[] } }) => {
      state.categories = action.payload.data;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCategories.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });

    builder.addCase(getCategories.fulfilled, (state, action) => {
      state.categories = action.payload?.data?.items;
      state.pagination = action.payload?.data?.pagination;
      state.isSuccess = true;
      state.isLoading = false;
    });

    builder.addCase(getCategories.rejected, (state, action) => {
      state.error = action.error.message ?? "Unknown error";
      state.isSuccess = false;
      state.isLoading = false;
    });
  },
});
export const { updateCategory, updateCategoryStatus } = CategorySlice.actions;
export default CategorySlice.reducer;
